import { getAuth, linkWithCredential, GoogleAuthProvider, Auth } from 'firebase/auth';

const PENDING_GOOGLE_CRED_KEY = 'pending_google_credential_jwt';

export function savePendingGoogleCredential(jwt: string): void {
  try { localStorage.setItem(PENDING_GOOGLE_CRED_KEY, jwt); } catch {}
}

export function getPendingGoogleCredential(): string | null {
  try { return localStorage.getItem(PENDING_GOOGLE_CRED_KEY); } catch { return null; }
}

export function clearPendingGoogleCredential(): void {
  try { localStorage.removeItem(PENDING_GOOGLE_CRED_KEY); } catch {}
}

/**
 * Attempt to link a previously saved Google credential with the currently signed-in user.
 * Returns true if linking succeeded, false if nothing to link or linking failed.
 */
export async function attemptLinkPendingGoogle(auth?: Auth): Promise<boolean> {
  const jwt = getPendingGoogleCredential();
  if (!jwt) return false;

  const theAuth = auth || getAuth();
  const currentUser = theAuth.currentUser;
  if (!currentUser) return false;

  try {
    const credential = GoogleAuthProvider.credential(jwt);
    await linkWithCredential(currentUser, credential);
    clearPendingGoogleCredential();
    console.log('Linked Google credential to existing user UID:', currentUser.uid);
    return true;
  } catch (err: any) {
    console.warn('Failed to link pending Google credential:', err);
    // Do not clear pending cred for transient errors; only clear for
    // unrecoverable ones. Google ID tokens expire after ~1h, so a stale one
    // (auth/invalid-credential / user-token-expired) can never link again —
    // keeping it meant every future login retried a doomed link round trip.
    const code = err?.code || '';
    if (
      code === 'auth/credential-already-in-use' ||
      code === 'auth/email-already-in-use' ||
      code === 'auth/invalid-credential' ||
      code === 'auth/user-token-expired' ||
      code === 'auth/operation-not-allowed' ||
      code === 'auth/provider-already-linked'
    ) {
      clearPendingGoogleCredential();
    }
    return false;
  }
}


